$(function () {
    'use strict';

    RivalIQ.apps.Shell.execute('show:app', {
        app: RivalIQ.apps.AccountStatus,
        options: {
            title: 'Account Suspended'
        }
    });
});
